import React, { Component } from 'react';
import { AddPatient } from '../components';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';

import { addPatient as actions } from '../actions';
const { InviteStates } = AddPatient;

@connect((state) => ({
  patientData: state.addPatient
}))
export default class AddPatientPage extends Component {

  componentDidMount() {
    this.props.dispatch(actions.createNewPatient());
  }
  
  render() {
    const { patientData } = this.props;
    // TODO: pass invite data into add patient component
    return (
        <AddPatient onSendSms={this.onSendSms}
                    onSendEmail={this.onSendEmail}
                    smsState={patientData.get('smsState')}
                    emailState={patientData.get('emailState')}
                    onDone={this.onDone}/>
    );
  }

  onSendSms = (invite) => {
    const { dispatch } = this.props;
    dispatch(actions.sendSms(invite.phoneNumber, invite.firstName, invite.lastName));
  };

  onSendEmail = (invite) => {
    const { dispatch } = this.props;
    dispatch(actions.sendEmail(invite.emailAddress, invite.firstName, invite.lastName));
  };

  onDone = () => {
    hashHistory.push('/patients');
  };
}



// WEBPACK FOOTER //
// ./src/pages/add-patient.js